'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');
const { inlineDatesAdverb } = require('../../../messageCenter/momentLocales.es');

function HoldExpiration({ expirationDate }) {
    const expirationDateCountdown = ` Expires ${moment(expirationDate)
        .locale('inlineDatesAdverb', inlineDatesAdverb)
        .fromNow()}`;
    return <span className="pdp-sidebar-hold-countdown">{expirationDateCountdown}</span>;
}

HoldExpiration.propTypes = {
    expirationDate: PropTypes.string.isRequired,
};

function CustomHold({ customHoldCopy, expirationDate }) {
    return (
        <div className="pdp-sidebar-hold-for-you">
            {customHoldCopy}
            {expirationDate ? <HoldExpiration expirationDate={expirationDate} /> : null}
        </div>
    );
}

CustomHold.propTypes = {
    customHoldCopy: PropTypes.string.isRequired,
    expirationDate: PropTypes.string,
};

module.exports = CustomHold;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Sidebar/CustomHold.jsx